import(/* webpackMode: "eager" */ "/build/node_modules/.pnpm/next@14.2.4_@babel+core@7.23.3_@opentelemetry+api@1.9.0_@playwright+test@1.47.1_babel-p_eef05be57d54a2a628a292d0033cf4cc/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/.pnpm/next@14.2.4_@babel+core@7.23.3_@opentelemetry+api@1.9.0_@playwright+test@1.47.1_babel-p_eef05be57d54a2a628a292d0033cf4cc/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TikTokNavigation","AIToolNavigation","KnowledgeNavigation","AiNavigation"] */ "/build/src/03-presenters/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/03-presenters/components/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreProvider"] */ "/build/src/app/[locale]/ai/StoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/app/[locale]/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FourthBox"] */ "/build/src/app/[locale]/FourthBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FourthBoxV2"] */ "/build/src/app/[locale]/FourthBoxV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/app/[locale]/Partner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/app/[locale]/SearchBtnV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecondBoxV3"] */ "/build/src/app/[locale]/SecondBoxV3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/app/[locale]/UserInfoWrapper.tsx");
